export class MatrixUserService {
    httpClient;
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Log in to the matrix node with username and password
     *
     * @param user
     * @param password
     * @param deviceId
     */
    async login(user, password, deviceId) {
        return this.httpClient.post('/login', {
            type: 'm.login.password',
            identifier: {
                type: 'm.id.user',
                user
            },
            password,
            device_id: deviceId
        });
    }
}
//# sourceMappingURL=MatrixUserService.js.map